import axios from "axios";
import { queryParams } from "../../../../utils/queryParams";

const instance = axios.create({
  baseURL: queryParams.apiVersion + "admin/organization_roles"
});

export const api = {
  getRoles(params) {
    return instance.get("", params);
  },
  addRole(params) {
    return instance.post("", params);
  },
  getRoleById(id, params) {
    return instance.get(`/${id}`, params);
  },
  updateRole(id, params) {
    return instance.put(`/${id}`, params);
  },
  removeRole(id) {
    return instance.delete(`/${id}`);
  },
  getPermissions(params) {
    return instance.get("/permission_list", params);
  },
};
